<template>
  <div id="app">
    <!-- <router-view name="blank"></router-view> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" name="blank"></router-view>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view name="blank"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
  }
</script>

<style lang="scss">
  #app {
    background-color: #222d32;
  }
  .suo{
  text-align: center;
  border: 1px solid #e9e9eb;
  border-radius: 30px;
  font-size: 12px;
  display: inline-block;
  padding: 0px 10px;
}
.el-table .el-table__fixed-header-wrapper th, .el-table .el-table__header-wrapper th{
    font-size: 14px !important;
}
.el-tag{
    border-radius: 40px !important;
    font-size: 12px !important;
}
.el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #DCDFE6;
    border-radius: 4px 0 0 4px !important;
    box-shadow: none !important;
}
.el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 4px 4px 0 !important;
}
</style>
